export function observationRows(attempt) {
  const event = value => value === true ? 'Event reported' : value === false ? 'No event reported; coverage unknown' : 'Not available'
  const count = attempt.leaveAssessmentWindowCount
  return [
    ['Mouse exits', Number.isInteger(count) && count >= 0 ? `${count} reported; coverage unknown` : 'Not available'],
    ['Full-screen exit', event(attempt.hasExitedFullScreen)],
    ['IP address change', event(attempt.ipAddressChanged)],
    ['Camera enabled', attempt.webcam === true ? 'Reported enabled; no recording evidence supplied' : 'Not available']
  ]
}
